var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"home"},[_c('MainComponent',{attrs:{"data":_vm.data}}),_c('HomeCatalogListComponent',{attrs:{"catalogs":_vm.catalogs}}),_c('HomeBannerComponent'),_c('ReviewsComponent',{attrs:{"title":"Спасибо за ваши отзывы","data":_vm.reviews}}),_c('FaqComponent',{attrs:{"data":_vm.faq}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }